import { MapPin } from 'lucide-react';
import { useState } from 'react';
import GoogleMap from './GoogleMap';
interface LocationSectionProps {
  property: {
    id: string;
    title: string;
    location: string;
    latitude?: number;
    longitude?: number;
    neighborhood?: {
      city: string;
      state: string;
      country: string;
      description: string;
      longDescription: string;
    };
  };
}
const LocationSection = ({
  property
}: LocationSectionProps) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const neighborhoodInfo = property.neighborhood || {
    city: property.location.split(',')[0]?.trim() || 'Ciudad',
    state: property.location.split(',')[1]?.trim() || 'Estado',
    country: 'País',
    description: 'Información de ubicación no disponible.',
    longDescription: 'Información detallada de ubicación no disponible.'
  };

  // Split long description by \n\n to create paragraphs
  const paragraphs = neighborhoodInfo.longDescription.split('\n\n');
  const fullText = neighborhoodInfo.longDescription;
  const shouldTruncate = fullText.length > 300;
  const truncatedText = shouldTruncate ? fullText.substring(0, 300) : fullText;
  return <div className="py-6 border-b border-gray-200">
      <h3 className="text-xl font-semibold mb-6">Dónde vas a estar</h3>
      
      {/* Google Map */}
      {property.latitude && property.longitude && <div className="mb-6">
          <GoogleMap latitude={property.latitude} longitude={property.longitude} title={property.title} />
        </div>}
      
      {/* Location Info */}
      <div className="space-y-2">
        <div className="flex items-start space-x-3">
          <MapPin className="w-5 h-5 text-gray-600 mt-1 flex-shrink-0" />
          <div className="w-full">
            <h4 className="font-semibold text-gray-900 mb-2 ">
              {neighborhoodInfo.city}, {neighborhoodInfo.state}, {neighborhoodInfo.country}
            </h4>
          </div>
        </div>
        
        {/* Description with show more functionality */}
        <div className="w-full">
          {showFullDescription ? <div className="space-y-4">
              {paragraphs.map((paragraph, index) => <p key={index} className="text-gray-600 leading-relaxed">
                  {paragraph}
                </p>)}
            </div> : <p className="text-gray-600 leading-relaxed">
              {truncatedText}
              {shouldTruncate && '...'}
            </p>}
          
          {shouldTruncate && <button onClick={() => setShowFullDescription(!showFullDescription)} className="mt-2 text-gray-900 font-medium underline hover:no-underline transition-all">
              {showFullDescription ? 'Mostrar menos' : 'Mostrar más'}
            </button>}
        </div>
      </div>
    </div>;
};
export default LocationSection;